module.exports = __webpack_public_path__ + "static/Foto2-9c55318c0beb31953d09aad119786307.png";